/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPdfTemplateDto } from './GetPdfTemplateDto';
import {
    GetPdfTemplateDtoFromJSON,
    GetPdfTemplateDtoFromJSONTyped,
    GetPdfTemplateDtoToJSON,
} from './GetPdfTemplateDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';

/**
 * 
 * @export
 * @interface GetSavedPdfExternalReferralDto
 */
export interface GetSavedPdfExternalReferralDto {
    /**
     * 
     * @type {string}
     * @memberof GetSavedPdfExternalReferralDto
     */
    id: string;
    /**
     * 
     * @type {GetPdfTemplateDto}
     * @memberof GetSavedPdfExternalReferralDto
     */
    pdfTemplate: GetPdfTemplateDto;
    /**
     * 
     * @type {string}
     * @memberof GetSavedPdfExternalReferralDto
     */
    examNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSavedPdfExternalReferralDto
     */
    creationDate: Date;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetSavedPdfExternalReferralDto
     */
    creator: GetUserDto;
}

/**
 * Check if a given object implements the GetSavedPdfExternalReferralDto interface.
 */
export function instanceOfGetSavedPdfExternalReferralDto(value: object): value is GetSavedPdfExternalReferralDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('pdfTemplate' in value) || value['pdfTemplate'] === undefined) return false;
    if (!('examNumber' in value) || value['examNumber'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('creator' in value) || value['creator'] === undefined) return false;
    return true;
}

export function GetSavedPdfExternalReferralDtoFromJSON(json: any): GetSavedPdfExternalReferralDto {
    return GetSavedPdfExternalReferralDtoFromJSONTyped(json, false);
}

export function GetSavedPdfExternalReferralDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSavedPdfExternalReferralDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'pdfTemplate': GetPdfTemplateDtoFromJSON(json['pdfTemplate']),
        'examNumber': json['examNumber'],
        'creationDate': (new Date(json['creationDate'])),
        'creator': GetUserDtoFromJSON(json['creator']),
    };
}

export function GetSavedPdfExternalReferralDtoToJSON(value?: GetSavedPdfExternalReferralDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'pdfTemplate': GetPdfTemplateDtoToJSON(value['pdfTemplate']),
        'examNumber': value['examNumber'],
        'creationDate': ((value['creationDate']).toISOString()),
        'creator': GetUserDtoToJSON(value['creator']),
    };
}

